'use strict';

const { find } = require('underscore');

const BaseView = require('./base');

const { any } = require('underscore');

class PickersView extends BaseView {
  initialize() {
    this.setModule('glive_booking_redesign');
  }

  add({ view, model, collection, selection: initialSelection, selected }) {
    if (this.pickers == null) {
      this.pickers = [];
    }

    const picker = new view({
      model,
      collection: model.get(collection),
      selected: initialSelection,
      previous: this.pickers[this.pickers.length - 1],
    });

    picker.on('select', selection => {
      selected(selection);

      this.pickers.forEach(selectPicker => selectPicker.autoSelect());

      const nextPicker = this.nextUnselectedPicker();

      if (nextPicker) {
        this.collapse(true);
        this.expand(nextPicker);
      } else {
        this.trigger('collapse');
        picker.once('collapsed', () => this.trigger('collapsed'));
        this.collapse(false);
      }
    });

    picker.on('expand', newPicker => {
      if (this.picker) {
        this.collapse(true);
      }

      this.setActivePicker(newPicker);
    });

    picker.on('collapse', this.unsetActivePicker, this);

    this.pickers.push(picker);

    return picker;
  }

  expanded() {
    return any(this.pickers, picker => picker.isVisible);
  }

  render() {
    super.render(...arguments);

    this.pickers.forEach(picker => {
      this.$el.append(picker.render().el);
    });

    setTimeout(() => this.postRender(), 1000);
    return this;
  }

  postRender() {
    const picker = this.nextUnselectedPicker();
    if (picker) {
      this.expand(picker);
    }
  }

  expand(picker) {
    picker.show();
    picker.once('expanded', () => this.trigger('expanded'));
  }

  nextUnselectedPicker() {
    return find(this.pickers, picker => !picker.selected());
  }

  collapse() {
    return this.picker.hide(true);
  }

  setActivePicker(picker) {
    if (picker) {
      this.picker = picker;
    }
    return picker;
  }

  unsetActivePicker() {
    return delete this.picker;
  }
}

module.exports = PickersView;
